import { useEffect } from 'react';

import useAppNavigation from '~/hooks/useAppNavigation';

interface Props {
  message: string;
  when: boolean;
}

export default function NavigationPrompt({ message, when }: Props) {
  const { block } = useAppNavigation();

  useEffect(() => {
    if (!when) {
      return undefined;
    }

    return block(message);
  }, [block, message, when]);

  return null;
}
